import { DecommissionASiteInventoryCheckType } from '../../../context/DecommissionASiteContext';
import { InventoryData } from '../../inventoryCheck/InventoryCheck';

export function buildChatData(
  inventoryData: DecommissionASiteInventoryCheckType | InventoryData,
  mpxn: string,
  chatReason: string,
) {
  const chf = inventoryData.data.find((device) => device.deviceType === 'CHF')?.deviceId;
  const chfText = chf ? chf : 'N/A';
  const mpxnText = mpxn ? mpxn : 'N/A';
  const addressText = inventoryData.address ? inventoryData.address : 'N/A';

  return `Hi
I can see you need assistance with: ${chatReason}.

MPxN: ${mpxnText}
CHF: ${chfText}
Address:
${addressText}

Result: Failed`;
}
